import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

export const markersList = {};

export const getMarker = (id) => {
    return markersList[id];
};

export const removeMarker = (id) => {
    if (markersList[id]) {
        markersList[id].remove();
        delete markersList[id];
    }
};

export const createMarker = (map, lngLat, title, content, icon, id, callback, flyTo) => {
    return new Promise(async (resolve, reject) => {
        const d = `<div class="iw-subTitle text-dark">
            ${title}
        </div>
        <div class="iw-content text-dark">
            ${content}
        </div>`;
        if (markersList[id]) {
            if (document.getElementsByClassName('maplibregl-popup').length > 0) {
                return;
            }
            removeMarker(id);
        }
        const el = document.createElement('div');
        const image = new Image();
        const generateDataMarker = () => {
            return new Promise((resolve) => {
                el.className = 'marker';
                image.src = icon;
                image.onload = () => {
                    resolve();
                };
                image.onerror = () => {
                    reject(new Error('Erreur lors du chargement de l\'image' + icon));
                };
            });
        };
        await generateDataMarker();
        el.style.width = '40px';
        el.style.height = '40px';
        el.style.backgroundRepeat = 'no-repeat';
        el.style.backgroundImage = `url(${icon})`;

        const popup = new maplibregl.Popup({ offset: 25 })
            .setHTML(d)
            .setLngLat(lngLat)
            .setMaxWidth('300px')
            .addTo(map);
        const _marker = new maplibregl.Marker({ element: el, anchor: 'bottom' })
            .setLngLat(lngLat)
            .setPopup(popup)
            .addTo(map);
        _marker.callback = callback;

        el.addEventListener('click', (e) => {
            e.stopPropagation();
            if (_marker.callback) {
                map.flyTo({ center: lngLat, zoom: 13 });
                _marker.callback();
            }
            _marker.togglePopup();
        });
        _marker.id = id;
        el.id = `_marker-${id}`;
        markersList[id] = _marker;
        if (flyTo) {
            map.flyTo({ center: lngLat, zoom: 13 });
        }
        resolve(_marker);
    });
};
